import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useSubCategoriesDocumentDetails } from "./travller.hooks";

const AddEditTravllerEssential = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);
  const {
    data: editSubCategories,
    isLoading: drilldownLoading,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(currentAirport ?? "klia1");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) refetchDocument();
  }, [query.get("id")]);
  useEffect(() => {
    refetchSubCategories();
  }, []);
  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      mandarin_title:
        decodeHTML(editSubCategoriesById?.payload?.mandarin_title) ||
        decodeHTML(editSubCategories?.mandarin_title) ||
        "",

      malay_title:
        decodeHTML(editSubCategoriesById?.payload?.malay_title) || decodeHTML(editSubCategories?.malay_title) || "",

      english_title:
        decodeHTML(editSubCategoriesById?.payload?.english_title) || decodeHTML(editSubCategories?.english_title) || "",

      description_mandarin:
        decodeHTML(editSubCategoriesById?.payload?.description_mandarin) ||
        decodeHTML(editSubCategories?.description_mandarin) ||
        "",

      description_malay:
        decodeHTML(editSubCategoriesById?.payload?.description_malay) ||
        decodeHTML(editSubCategories?.description_malay) ||
        "",

      description_english:
        decodeHTML(editSubCategoriesById?.payload?.description_english) ||
        decodeHTML(editSubCategories?.description_english) ||
        "",

      airport: decodeHTML(editSubCategoriesById?.payload?.airport) || decodeHTML(editSubCategories?.airport) || "",

      image: editSubCategoriesById?.payload
        ? [
            {
              uid: "-1",
              name: "image.jpg",
              status: "done",
              url: decodeHTML(editSubCategoriesById?.payload?.image),
            },
          ]
        : editSubCategories
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: decodeHTML(editSubCategories?.image),
              },
            ]
          : "",
    },
    fields: fields.travellerEssentialsOverview,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    try {
      let imageKeys: any = ["image"];
      for (const key of imageKeys) {
        try {
          let field = data[key];
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = data[key][0].url;
          }
        } catch (error) {}
      }

      const payload = {
        action,
        method,
        module: "Home Page",
        subModule: `${query.get("activeTab")}_${query.get("subActiveTab")}`,
        type: "DEDICATED",
        application: "PASSENGER_ECMS",
        airportName: currentAirport,
        reviewNotes,
        appList: [
          {
            appName: "PASSENGER_ECMS",
            apiUrl,
          },
        ],
        payload: {
          ...(action === "UPDATE" && {
            id: editSubCategories?.id || editSubCategoriesById?.payload?.id,
          }),
          ...data,
          title: data?.english_title ?? "",
          airport: currentAirport,
          published: true,
        },
        status,
      };

      // Submit to API
      if (query.get("id")) {
        await put(`/management/update-document?approvalId=${query.get("id")}`, payload);
        openToast({
          content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
          type: "success",
        });
        navigate(
          status === "PENDING"
            ? "/dedicated/status-information?activeTab=pending"
            : "/dedicated/status-information?activeTab=draft"
        );
      } else {
        await post("/management/publish", payload);
        openToast({
          content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
          type: "success",
        });
        navigate(
          status === "PENDING"
            ? "/dedicated/status-information?activeTab=pending"
            : "/dedicated/status-information?activeTab=draft"
        );
      }
    } catch (error) {
      openToast({
        content: "Failed to save data",
        type: "error",
      });
      console.error("Error submitting Traveller Essential:", error);
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingSubCategories || drilldownLoading}
      config={epcApplicationsFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${passengerHost}/api/traveller-essentials-all-fields/${
            editSubCategories?.id || editSubCategoriesById?.payload?.id
          }`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Homepage"
    />
  );
};

export default AddEditTravllerEssential;
